import { useState } from "react";
import { Loader2, Phone, MessageCircle, Mail, Send } from "lucide-react";
import toast from "react-hot-toast";
import driverApi from "../../utils/driverApi";
import { useDriverHelp } from "../../hooks/useDriverPortal";

const inputStyle = {
  width: "100%", boxSizing: "border-box", padding: "10px 12px",
  background: "#F9FAFB", border: "1.5px solid #E5E7EB", borderRadius: 8, fontSize: 13.5, color: "#111827", outline: "none", fontFamily: "inherit",
};

function ContactButton({ icon: Icon, label, href }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" style={{
      display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", flex: "1 1 160px",
      background: "#fff", border: "1px solid #E5E7EB", borderRadius: 10, textDecoration: "none", color: "#111827",
    }}>
      <Icon size={16} color="#4F46E5" /> <span style={{ fontSize: 13.5, fontWeight: 600 }}>{label}</span>
    </a>
  );
}

export default function DriverHelp() {
  const { data, loading } = useDriverHelp();
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  async function handleRaiseTicket(e) {
    e.preventDefault();
    if (!message.trim()) return toast.error("Please describe your issue");
    setSending(true);
    try {
      await driverApi.post("/api/driver/support-ticket", { description: message.trim() });
      toast.success("Your message has been sent to your fleet owner");
      setMessage("");
    } catch (err) {
      toast.error(err.message || "Failed to send. Please try contacting your owner directly.");
    } finally {
      setSending(false);
    }
  }

  if (loading || !data) {
    return (
      <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Loader2 size={18} style={{ animation: "spin 1s linear infinite", color: "#9CA3AF" }} />
      </main>
    );
  }

  return (
    <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB" }}>
      <div style={{ maxWidth: 600, margin: "0 auto", padding: "28px 24px" }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: "#111827", marginBottom: 2 }}>Help & Support</div>
        <div style={{ fontSize: 13, color: "#6B7280", marginBottom: 20 }}>Contact {data.orgName}</div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 20 }}>
          {data.orgPhone && <ContactButton icon={Phone} label={`Call ${data.orgPhone}`} href={`tel:${data.orgPhone}`} />}
          {data.orgPhone && <ContactButton icon={MessageCircle} label="WhatsApp" href={`https://wa.me/91${data.orgPhone}`} />}
          {data.orgEmail && <ContactButton icon={Mail} label="Email" href={`mailto:${data.orgEmail}`} />}
        </div>

        <form onSubmit={handleRaiseTicket} style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: "18px 20px", display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>Raise a Ticket</div>
          <textarea rows={4} placeholder="Describe your issue…" style={inputStyle} value={message} onChange={e => setMessage(e.target.value)} />
          <button type="submit" disabled={sending} style={{ height: 40, borderRadius: 9, border: "none", background: sending ? "#9CA3AF" : "#4F46E5", color: "#fff", fontWeight: 700, fontSize: 13.5, cursor: sending ? "default" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
            <Send size={13} /> {sending ? "Sending…" : "Send"}
          </button>
        </form>
      </div>
    </main>
  );
}
